import { render, staticRenderFns } from "./Chem1LD_Q1S1_HazardsTable.vue?vue&type=template&id=d8c0f8ba&scoped=true&"
import script from "./Chem1LD_Q1S1_HazardsTable.vue?vue&type=script&lang=js&"
export * from "./Chem1LD_Q1S1_HazardsTable.vue?vue&type=script&lang=js&"
import style0 from "./Chem1LD_Q1S1_HazardsTable.vue?vue&type=style&index=0&id=d8c0f8ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c0f8ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCombobox,VContainer,VImg,VSelect})
